<template>
  <v-container fluid class="mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
                    <v-btn color="default" class="button-shadow mb-2 mr-0 mr-sm-2" v-on:click="PrintElement('print-page')">
                      <v-icon class="mr-2">mdi-printer</v-icon>
                      Print
                    </v-btn>
                    <v-btn color="success" class="button-shadow" @click="Done">
                      <v-icon class="mr-2">mdi-check</v-icon>
                      Done
                    </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12" id="print-page">
        <v-row class="print-page">
          <v-col cols="12" md="8" sm="12">
            <v-card class="ma-1">
              <v-card-text class="printBody">
                <v-row>&nbsp;</v-row>
                <v-row justify="space-between">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;">
                    <tr>
                      <td style="width:40%"><img :src="logo" height="50"  alt="Logo" /></td>
                      <td></td>
                      <td style="width: 35%; text-align: right; vertical-align: text-top">
                         <table style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Date</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{ new Date(initvalue.policydate).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
                          </tr>
                         </table> 

                      </td>
                    </tr>
                    <tr>
                      <td colspan="3"><div align="center"><h4 class="ma-0">{{ initvalue.policyname }}</h4></div></td>
                    </tr>
                  </table>
                </v-row>
                <v-row class="mb-5 greyBold--text">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;" cellpadding="0" cellspacing="0">
                    <tr  v-for="(detail) in initvalue.details"  v-bind:key="detail._id">
                      <td style="width: 100%; vertical-align: text-top; margin-bottom: 10px;">
                        <div>
                          <p style="margin-top: 30px;margin-bottom: 5px;"><span style="font-size: 13pt; font-weight: bold">{{ detail.detailheading }}</span></p>
                          <p class="text-wrap" style="margin-top: 0;margin-bottom: 0; white-space: pre;"><span style="font-size: 12pt;"  v-html="detail.detailtext"></span></p>
                        </div>
                      </td>
                    </tr>
                  </table>
                  <div>&nbsp;&nbsp;</div>
                </v-row>

                <p style="margin-top: 0; margin-bottom: 70px">&nbsp;</p>
                <table style="width: 50%" cellpadding="0" cellspacing="0">
                <tr><td style="text-align: right; border-bottom: 2px; border-bottom-style: solid"></td><td></td></tr>
                </table>
                <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
    import {mapActions, mapState} from "vuex";
    export default {
        name: 'PrintPage',
        data(){
          return {
            initvalue: {},
            logo: null,
            details: [],
          };
        },
        methods: {
          ...mapActions('Employee', ['getEmployeesRequest']),
          ...mapActions('Account', ['getAccountsRequest']),
          Done(){
            this.$router.push({ name: 'PolicyList' });
          },
          PrintElement(divid) {
            var content = document.getElementById(divid).innerHTML;
            var mywindow = window.open('', 'Print', 'height=800,width=1000,menubar=0,location=0,status=0,titlebar=0,toolbar=0');

            mywindow.document.write('<html><head><title>Print</title>');
            mywindow.document.write('</head><body onclick="window.print();">');
            mywindow.document.write(content);
            mywindow.document.write('</body></html>');

            mywindow.document.close();
            mywindow.focus()
            mywindow.print();
            return;
          }
        },
        computed: {
          ...mapState('Account', ['accounts']),
          ...mapState('Employee', ['employees']),
        },
        created () {
          this.initvalue = this.$route.params;
          if(!this.initvalue._id) this.$router.push({ name: 'PolicyList' });
          this.details = this.initvalue.details;
          this.details.sort((a,b) =>{
          if (b.detailrank > a.detailrank) return -1;
          if (a.detailrank < b.detailrank) return 1;
          return 0;
        });
          if(this.accounts.length==0) this.getAccountsRequest();
          if(this.initvalue.companyid=='60a8acb67418a3429476cd42'){
            this.logo = 'https://tradexc-storage.s3.ap-southeast-1.amazonaws.com/temp/lhs-logo.png';
          }
          else if(this.initvalue.companyid=='60b07f300d820029acae4734'){
            this.logo = 'https://tradexc-storage.s3.ap-southeast-1.amazonaws.com/temp/alh-logo.png';
          }   
        },
    };
</script>

<style src="./Print.scss" lang="scss" scoped />
